(function () {
  'use strict';

  var API = '/apps/natuka-subscriptions/referrals/widget-data';

  function init() {
    var widget = document.getElementById('ff-mgm-widget');
    if (!widget) return;

    if (widget.dataset.loggedIn === 'false') {
      setState(widget, 'not_logged_in');
      setLoginCtaUrl(widget);
      return;
    }

    setState(widget, 'loading');

    fetch(API, { credentials: 'include', headers: { 'Accept': 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .then(function (data) { applyData(widget, data); })
      .catch(function () { setState(widget, 'error'); });
  }

  function applyData(widget, data) {
    if (!data.programEnabled) {
      var state = data.reason === 'not_logged_in' ? 'not_logged_in' : 'no_subscription';
      setState(widget, state);
      setLoginCtaUrl(widget);
      return;
    }

    setState(widget, 'active');
    setLoginCtaUrl(widget);

    var code = data.code || '';
    var linkEl = widget.querySelector('[data-ff-referral="link"]');
    var pageUrl = linkEl ? (linkEl.dataset.ffPageUrl || '') : '';
    var link = pageUrl && code ? window.location.origin + pageUrl + '?ref=' + code : '';
    var tier = data.tier || {};
    var nextTier = tier.nextTier || null;
    var tierPct = tier.percentage != null ? tier.percentage : 0;
    var activeCount = data.activeReferralsCount || 0;

    widget.querySelectorAll('[data-ff-referral="active-view"]').forEach(function (el) {
      el.dataset.ffTier = String(tierPct);
    });

    widget.querySelectorAll('[data-ff-referral="progress-bar"]').forEach(function (bar) {
      var fill = bar.querySelector('.ff-mgm-progress-bar-fill');
      if (fill) {
        var pct = nextTier ? Math.min(100, Math.round(activeCount / nextTier.at * 100)) : 100;
        fill.style.width = pct + '%';
      }
    });

    widget.querySelectorAll('[data-ff-referral="link"]').forEach(function (el) {
      el.textContent = truncateMiddle(link, 19, 11);
      el.addEventListener('click', function () {
        copyText(link);
        var linkBlock = el.closest('[id^="shopify-block-"]');
        var copyBtn = linkBlock && linkBlock.parentElement
          ? linkBlock.parentElement.querySelector('[data-ff-referral="copy-btn"]')
          : null;
        if (copyBtn) showCopied(copyBtn);
      });
    });

    widget.querySelectorAll('[data-ff-referral="copy-btn"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        copyText(link);
        showCopied(btn);
      });
    });

    widget.querySelectorAll('[data-ff-wa-message]').forEach(function (btn) {
      var msg = (btn.dataset.ffWaMessage || '').replace('{link}', link);
      btn.href = 'https://wa.me/?text=' + encodeURIComponent(msg);
    });

    widget.querySelectorAll('[data-ff-email-subject]').forEach(function (btn) {
      var subject = btn.dataset.ffEmailSubject || '';
      var body = (btn.dataset.ffEmailBody || '').replace('{link}', link);
      btn.href = 'mailto:?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    });
  }

  function truncateMiddle(str, start, end) {
    if (str.length <= start + end + 3) return str;
    return str.slice(0, start) + '...' + str.slice(-end);
  }

  function setState(widget, state) {
    widget.dataset.state = state;
  }

  function setText(widget, key, value) {
    widget.querySelectorAll('[data-ff-referral="' + key + '"]').forEach(function (el) {
      el.textContent = value;
    });
  }

  function setLoginCtaUrl(widget) {
    widget.querySelectorAll('[data-ff-referral="login-cta"]').forEach(function (el) {
      if (el.dataset.ffLoginUrl) return;
      el.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname);
    });
  }

  function copyText(text) {
    if (!text) return;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).catch(function () { execCopyFallback(text); });
    } else {
      execCopyFallback(text);
    }
  }

  function execCopyFallback(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;opacity:0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  function showCopied(btn) {
    var labelCopied = btn.dataset.labelCopied;
    var labelCopy = btn.dataset.labelCopy;
    btn.textContent = labelCopied;
    btn.classList.add('ff-mgm-copy-btn--copied');
    setTimeout(function () {
      btn.textContent = labelCopy;
      btn.classList.remove('ff-mgm-copy-btn--copied');
    }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
